import { isFieldFixed } from "../../helpers";

export function bringFinanceSelectionInRange(newSheetData, fundingSection) {
  const funderSettings = newSheetData.defaults.funderTypeSettings.find(
    (obj) =>
      obj.funderType == fundingSection.funderType &&
      obj.calcTableType == fundingSection.calcTableType,
  );

  if (
    !fundingSection?.financeSelection?.value ||
    isFieldFixed(fundingSection?.financeSelection)
  ) {
    return;
  }

  fundingSection.financeSelection.value = Math.max(
    parseInt(fundingSection.financeSelection.value),
    funderSettings.vMinSelection,
  );
  fundingSection.financeSelection.value = Math.min(
    parseInt(fundingSection.financeSelection.value),
    funderSettings.vMaxSelection,
  );
}
